import { IFundName } from '../../core/services/firestore/apv-config.service';
import {
  GENERATIONAL_FUND_DESCRIPTIONS,
  IFundOption,
} from '../constants/regime-fund.constant';

const toGenerationalFund = ({ id, name }: IFundName): IFundOption => ({
  id,
  name,
  description: GENERATIONAL_FUND_DESCRIPTIONS[id] ?? '',
});

const birthYear = ({ birthYearFrom, birthYearTo }: IFundName): number =>
  birthYearFrom ?? birthYearTo ?? 0;

const byBirthYearDesc = (a: IFundName, b: IFundName): number =>
  birthYear(b) - birthYear(a);

export const toGenerationalFunds = (fundNames: IFundName[]): IFundOption[] =>
  [...fundNames].sort(byBirthYearDesc).map(toGenerationalFund);
